import 'globals';

(function ($, window, document, PageLoadedQueue) {
    window.PageLoadedQueue.addFunction(function() {
        if ($('#filterForm select').length) {
            $('#filterForm select').multiselect({
                numberDisplayed: 1,
                onDropdownHide: function (event) {
                    $('#filterForm').trigger('submit');
                }
            });
        }
    });
})(jQuery, window, document, window.PageLoadedQueue);
